/**
 * ドライバー現地情報
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/driver_schedules/order_locals`

const driver_schedule_order_local = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { order_id }) {
      const api_path = `${API_PATH}/${order_id}/`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default driver_schedule_order_local
